
import { MapLocation } from '@/types/location';

// CUPARDO Billiards Center Locations
export const cupardoBilliardsCenters: MapLocation[] = [
  {
    id: 54001,
    name: "CUPARDO Billiards - Riyadh (Al Morabaa)",
    type: "Game Center",
    devices: 3,
    coordinates: [24.64466988828733, 46.705210677911715],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Unisex",
    ageRange: "16-45",
    orientation: "Portrait",
    segment: "Game"
  }
];
